export const PercentageFormat = (number) => {
    if (isNaN(number) || number === null || number === undefined) {
        return "0.00%"; // Default value if number is invalid
    }
    return new Intl.NumberFormat("en-US", {
        style: "percent",
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    }).format(number / 100); // Divide by 100 since percentages are decimal-based
};